import React, { useEffect } from "react";
import { notifySdkConsentError } from "../utils/androidBridge";

const ConnectionFailed: React.FC = () => {
    useEffect(() => {
        notifySdkConsentError("Connection failed");
    }, []);

    return (
        <div className="p-6 text-red-600">
            Connection Failed. Try again.
        </div>
    );
};

export default ConnectionFailed;
